import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useCallback, memo } from 'react';
import * as S from 'console/billing/styles';
import { Box, CardContent, CardHeader, Tab, Tabs } from '@mui/material';
import * as React from 'react';
export const TabsPanelWithScroll = memo(function TabsPanelWithScroll(props) {
    const { title, arrayPanel, ...rest } = props;
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [touchPosition, setTouchPosition] = useState(null);
    const handleTouchStart = useCallback((event) => {
        const touchDown = event.touches[0].clientX;
        setTouchPosition(touchDown);
    }, []);
    const handleTouchMove = useCallback((event) => {
        if (touchPosition === null) {
            return;
        }
        const currentTouch = event.touches[0].clientX;
        const diff = touchPosition - currentTouch;
        if (diff > 20) {
            const newValue = value + 1;
            if (newValue < arrayPanel.length + 1) {
                return setValue(newValue);
            }
            return value;
        }
        if (diff < -20) {
            const newValue = value - 1;
            if (newValue > -1) {
                return setValue(newValue);
            }
            return value;
        }
    }, [touchPosition]);
    return (_jsxs(S.Card, { variant: "outlined", children: [title && (_jsx(CardHeader, { title: title, titleTypographyProps: { variant: 'h6' }, sx: { paddingBottom: '0' } })), _jsxs(CardContent, { sx: { paddingTop: '0' }, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, children: [_jsx(Box, { sx: {
                            borderBottom: 1,
                            borderColor: 'divider',
                        }, children: _jsx(Tabs, { value: value, onChange: handleChange, variant: "fullWidth", scrollButtons: true, allowScrollButtonsMobile: true, "aria-label": "scrollable auto tabs example", children: arrayPanel.map((array) => {
                                const style = array.style;
                                const icon = array?.props?.icon;
                                const iconPosition = array?.props?.iconPosition;
                                return (_jsx(Tab, { icon: icon && icon, iconPosition: iconPosition && iconPosition, label: array.title, wrapped: true, sx: style && style }, array.title));
                            }) }) }), arrayPanel.map((array, index) => (_createElement(CustomTabPanel, { value: value, index: index, ...rest, key: array.title }, array.component)))] })] }));
});
export const CustomTabPanel = memo(function CustomTabPanelProps(props) {
    const { children, value, index, ...rest } = props;
    return _jsx(_Fragment, { children: value === index && children });
});
